const syncState = {
    0: 'Pending',
    1: 'Processed',
    2: 'Error'
}

export default syncState;